import TextField from '@mui/material/TextField';
import { withStyles } from '@material-ui/core';

type TypeFieldText = {
    onChange: (event: any) => void,
    value: string | number | undefined,
    disabled?: boolean,
    onClick?: (event?: any) => void
}

const CssTextField = withStyles({
    root: {
        '& legend': {
            display: 'none',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'yellow',
        },
        '& .MuiOutlinedInput-root': {
            '& input': {
                zIndex: '999'
            },
            '& fieldset': {
                borderColor: '#ccc',
                paddingTop: '5px',
                backgroundColor: 'white'
            },
            '&:hover fieldset': {
                borderColor: '#ccc',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#ccc',
                borderWidth: '1px'
            },
        },
    },
})(TextField);

export const FieldText = (propsField: TypeFieldText) => {
    
    function teste(event: any) {
        propsField.onChange(event)
    }

    return (
        <CssTextField 
        onChange={teste} 
        value={propsField.value} 
        variant="outlined" 
        className="fieldText-input" 
        disabled={propsField.disabled !== undefined ? propsField.disabled : false}
        onClick={propsField.onClick}
        />
    )
}